import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { loginUser, clearError } from '../features/auth/authSlice';
import { authStorage } from '../utils/authStorage';
import './ntc-branding.css';

const Login = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error, isAuthenticated, user } = useAppSelector((state) => state.auth);
  
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // Check for encode-decode from url (for direct login links)
    // Temporarily disabled to test for error source
    /*
    let queryString = window.location.hash;
    
    if (queryString) {
      let de = decode(queryString.substring(1));
      de = decode(de.split("-")[0]);
      
      if (de !== "") {
        const credentials = de.split("-");
        setFormData({
          username: credentials[0],
          password: credentials[1]
        }, () => {
          handleLogin();
        });
      }
    }
    */
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.role === 6) {
        authStorage.setDirectLink('1');
        window.location.href = '/lp-dashboard';
      } else {
        authStorage.setDirectLink('0');
        window.location.href = '/upcoming';
      }
    }
  }, [isAuthenticated, user]);

  // Simple Ctrl+Enter handler only
  useEffect(() => {
    const handleKeyboardShortcut = (e) => {
      if (e.key === 'Enter' && e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        handleLogin();
      }
    };

    document.addEventListener('keydown', handleKeyboardShortcut);
    
    return () => {
      document.removeEventListener('keydown', handleKeyboardShortcut);
    };
  }, [formData]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (error) {
      dispatch(clearError());
    }
  };

  const handleLogin = async () => {
    const { username, password } = formData;
    
    if (!username || !password) {
      alert('Please provide username & password to login');
      return;
    }

    dispatch(loginUser({ username, password }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <main className="auth-minimal-wrapper">
      <div className="auth-minimal-inner">
        <div className="minimal-card-wrapper">
          <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
            <div className="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
              <img src="/assets/images/icon.png" alt="NTC Logo" className="img-fluid" />
            </div>
            <div className="card-body p-sm-5">
              <h2 className="fs-20 fw-bolder mb-4">Login</h2>
              <h4 className="fs-13 fw-bold mb-2">Login to your account</h4>
              <p className="fs-12 fw-medium text-muted">Welcome back to <strong>Newrtibe IMS</strong>, a platform to access all your investments.</p>
              <p className="fs-11 text-muted"><small>💡 Tip: Press <kbd>Ctrl</kbd> + <kbd>Enter</kbd> to login</small></p>
              
              {error && (
                <div className="alert alert-danger mb-3" role="alert">
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit} className="w-100 mt-4 pt-2">
                <div className="mb-4">
                  <input 
                    type="text" 
                    name="username"
                    className="form-control" 
                    placeholder="Username" 
                    value={formData.username}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                <div className="mb-3 position-relative">
                  <input 
                    type={showPassword ? 'text' : 'password'} 
                    name="password"
                    className="form-control pe-5" 
                    placeholder="Password" 
                    value={formData.password}
                    onChange={handleInputChange}
                    required 
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute top-50 end-0 translate-middle-y text-muted text-decoration-none p-2"
                    style={{ zIndex: 5, opacity: showPassword ? 1 : 0.7 }}
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? 'Hide password' : 'Show password'}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                    )}
                  </button>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="custom-control custom-checkbox">
                      <input type="checkbox" className="custom-control-input" id="rememberMe" />
                      <label className="custom-control-label c-pointer" htmlFor="rememberMe">Remember Me</label>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <button 
                    type="submit" 
                    className="btn btn-lg btn-primary w-100"
                    disabled={isLoading}
                    onClick={() => {
                      console.log('Button clicked!');
                      handleLogin();
                    }}
                  >
                    {isLoading ? 'Logging in...' : 'Login'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;